export default {
  name: 'PauseIcon',
  props: {
    width: {
      type: Number,
      default: 10
    },
    height: {
      type: Number,
      default: 10
    },
    color: {
      type: String,
      default: '#D7AA0F'
    }
  }
};